import moment from "moment";

export const formatDateShort = (dateStr) => {
  if (!dateStr) return '';
  const cleanStr = String(dateStr).trim();
  return cleanStr.includes(' ') ? cleanStr.split(' ') : cleanStr;
};

/**
 * 🛠️ GLOBÁLNÍ COUNTDOWN: Přepíná stavy a skloňuje celá slova se spojkou "a" na správném místě (bez vteřin)
 */
export const getLiveCountdownText = (dateStr, nowTime = moment()) => {
  if (!dateStr) return '';
  
  try {
    const cleanStr = String(dateStr).trim();
    const parts = cleanStr.split(' ');
    
    const datePart = parts[0];
    const formattedDate = datePart.split('.').join('-');
    
    let endTime;
    if (parts.length > 1) {
      endTime = moment(`${formattedDate} ${parts[1]}`, 'DD-MM-YYYY HH:mm:ss');
    } else {
      endTime = moment(formattedDate, 'DD-MM-YYYY').endOf('day');
    }

    const duration = moment.duration(endTime.diff(nowTime));
    const totalHoursLeft = duration.asHours();

    // Pokud čas vypršel
    if (duration.asSeconds() <= 0) return 'uzavřena';

    // ⏱️ STAV 3: Zbývá MÉNÊ NEŽ 2 DNY (< 48 hodin) -> České skloňování se spojkou "a"
    if (totalHoursLeft < 48) {
      const days = Math.floor(duration.asDays());
      const hours = duration.hours();
      const minutes = duration.minutes();

      // Pole, do kterého budeme sbírat nalezené časové úseky
      const segments = [];

      // 1. Skloňování DNŮ
      if (days > 0) {
        segments.push(days === 1 ? '1 den' : `${days} dny`);
      }

      // 2. Skloňování HODIN
      if (hours > 0) {
        if (hours === 1) segments.push('1 hodinu');
        else if (hours >= 2 && hours <= 4) segments.push(`${hours} hodiny`);
        else segments.push(`${hours} hodin`);
      }

      // 3. Skloňování MINUT
      if (minutes > 0) {
        if (minutes === 1) segments.push('1 minutu');
        else if (minutes >= 2 && minutes <= 4) segments.push(`${minutes} minuty`);
        else segments.push(`${minutes} minut`);
      }

      // 🛠️ SPOJKOVÁ LOGIKA OD AI: Spojíme pole textů přesně podle gramatiky
      let finalTimeStr = '';
      if (segments.length === 3) {
        // Pokud máme 3 úseky: "1 den, 2 hodiny a 5 minut"
        finalTimeStr = `${segments[0]}, ${segments[1]} a ${segments[2]}`;
      } else if (segments.length === 2) {
        // Pokud máme 2 úseky: "1 den a 7 minut" nebo "2 dny a 3 hodiny"
        finalTimeStr = `${segments[0]} a ${segments[1]}`;
      } else if (segments.length === 1) {
        // Pokud máme jen 1 úsek: "5 minut"
        finalTimeStr = segments[0];
      } else {
        finalTimeStr = 'méně než minutu';
      }

      return `za ${finalTimeStr}`;
    }

    // 📆 STAV 2: Mezi 2 a 5 DNY (48 až 120 hodin) -> Vrátí den v týdnu
    if (totalHoursLeft >= 48 && totalHoursLeft <= 144) {
      const czechDays = {
        0: 'v neděli',
        1: 'v pondělí',
        2: 'v úterý',
        3: 've středu',
        4: 've čtvrtek',
        5: 'v pátek',
        6: 'v sobotu'
      };
      return czechDays[endTime.day()];
    }

    // 📅 STAV 1: VÍCE NEŽ 5 DNÍ (> 120 hodin) -> Fixní datum z API
    if (totalHoursLeft > 120) {
      return dateStr;
    }

  } catch (e) {
    return dateStr;
  }
  return dateStr;
};

export const isRegisterActiveGlobal = (dateStr, nowTime = moment()) => {
  if (!dateStr) return false;
  try {
    const cleanStr = String(dateStr).trim().split(' ');
    const formattedDate = cleanStr[0].split('.').join('-');
    
    let endTime;
    if (cleanStr.length > 1) {
      endTime = moment(`${formattedDate} ${cleanStr[1]}`, 'DD-MM-YYYY HH:mm:ss');
    } else {
      endTime = moment(formattedDate, 'DD-MM-YYYY').endOf('day');
    }
    return endTime.diff(nowTime) > 0;
  } catch (e) {
    return false;
  }
};
